import { isQueryKey } from "react-query/types/core/utils"

export default function queryWrapper<T>(func: (...params: any) => T){
    return ({ queryKey }: { queryKey: string[] } ) => func(...queryKey.slice(1));
}